import { createAction, props } from '@ngrx/store';
import { EquipmentActivity } from '../_models';

// Action types
export const loadEquipmentActivities = createAction('[EquipmentActivity] Load EquipmentActivities');
export const loadEquipmentActivitiesSuccess = createAction(
  '[EquipmentActivity] Load EquipmentActivities Success',
  props<{ equipmentActivities: EquipmentActivity[] }>()
);
export const loadEquipmentActivitiesFailure = createAction(
  '[EquipmentActivity] Load EquipmentActivities Failure',
  props<{ error: any }>()
);

export const addEquipmentActivity = createAction(
  '[EquipmentActivity] Add EquipmentActivity',
  props<{ equipmentActivity: EquipmentActivity }>()
);
export const addEquipmentActivitySuccess = createAction(
  '[EquipmentActivity] Add EquipmentActivity Success',
  props<{ equipmentActivity: EquipmentActivity }>()
);
export const addEquipmentActivityFailure = createAction(
  '[EquipmentActivity] Add EquipmentActivity Failure',
  props<{ error: any }>()
);

export const updateEquipmentActivity = createAction(
  '[EquipmentActivity] Update EquipmentActivity',
  props<{ equipmentActivity: EquipmentActivity }>()
);
export const updateEquipmentActivitySuccess = createAction(
  '[EquipmentActivity] Update EquipmentActivity Success',
  props<{ equipmentActivity: EquipmentActivity }>()
);
export const updateEquipmentActivityFailure = createAction(
  '[EquipmentActivity] Update EquipmentActivity Failure',
  props<{ error: any }>()
);

export const deleteEquipmentActivity = createAction(
  '[EquipmentActivity] Delete EquipmentActivity',
  props<{ id: number }>()
);
export const deleteEquipmentActivitySuccess = createAction(
  '[EquipmentActivity] Delete EquipmentActivity Success',
  props<{ id: number }>()
);
export const deleteEquipmentActivityFailure = createAction(
  '[EquipmentActivity] Delete EquipmentActivity Failure',
  props<{ error: any }>()
);
